export const GET_AUDIENCE_LIST = "GET_AUDIENCE_LIST";
export const GET_AUDIENCE = "GET_AUDIENCE";
export const CREATE_AUDIENCE = "CREATE_AUDIENCE";
export const BUILD_AUDIENCE = "BUILD_AUDIENCE";
export const DELETE_AUDIENCE = "DELETE_AUDIENCE";
export const UPDATE_AUDIENCE = "UPDATE_AUDIENCE";
export const RESET_AUDIENCE_STATUS = "RESET_AUDIENCE_STATUS";
export const SHARE_AUDIENCE = "SHARE_AUDIENCE";

export const CREATE_INSIGHT = "CREATE_INSIGHT";
export const CHANGE_DESCRIPTION = "CHANGE_DESCRIPTION";
export const CHANGE_INSIGHT_META = "CHANGE_INSIGHT_META";

export const ADD_VARIABLE_GROUP = "ADD_VARIABLE_GROUP";
export const REMOVE_VARIABLE_GROUP = "REMOVE_VARIABLE_GROUP";
export const RESET_VARIABLE_GROUP = "RESET_VARIABLE_GROUP";
export const CHANGE_OPERATOR = "CHANGE_OPERATOR";
export const CHANGE_BUILD_MODE = "CHANGE_BUILD_MODE";
export const CHANGE_GROUP_OPERATOR = "CHANGE_GROUP_OPERATOR";
export const CHANGE_GROUP_VARIABLES = "CHANGE_GROUP_VARIABLES";
export const ADD_SEGMENTS = "ADD_SEGMENTS";
export const CHANGE_SEGMENT = "CHANGE_SEGMENT";
export const ADD_UPLOAD_FILE = "ADD_UPLOAD_FILE";
export const CHECK_UPLOAD_FILE = "CHECK_UPLOAD_FILE";
export const CLEAR_UPLOAD_FILE = "CLEAR_UPLOAD_FILE";
export const CHANGE_UPLOAD_MODE = "CHANGE_UPLOAD_MODE";
export const CHANGE_NAME = "CHANGE_NAME";
export const SET_GEO_FENCE = "SET_GEO_FENCE";
export const SET_STATUS = "SET_STATUS";

export const GET_ACTIVATION_LIST = "GET_ACTIVATION_LIST";
export const GET_ACTIVATION = "GET_ACTIVATION";
export const CREATE_ACTIVATION = "CREATE_ACTIVATION";
export const BUILD_ACTIVATION = "BUILD_ACTIVATION";
export const DELETE_ACTIVATION = "DELETE_ACTIVATION";
export const UPDATE_ACTIVATION = "UPDATE_ACTIVATION";
export const SHARE_ACTIVATION = "SHARE_ACTIVATION";

export const SET_SITES = "SET_SITES";
export const SET_SITE_CATCHMENT = "SET_SITE_CATCHMENT";
export const SET_SITE_CATEGORIES = "SET_SITE_CATEGORIES";
export const SET_SITE_DAY_TYPE = "SET_SITE_DAY_TYPE";

export const CHANGE_TRAVELTIME = "CHANGE_TRAVELTIME";

export const LOADING = "LOADING";
export const RESET = "RESET";
export const ERROR = "ERROR";
